/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getMyJobsAction,
  editJobAction,
  deleteJob,
  suspendJob,
  closeJob,
  getJobLevelsAction,
} from "../../../redux/actions/jobActions";
import { SectionLoader } from "../../../components/PageLoader";
import icons from "../../../assets/icons/icon-collection.svg";
import EmptyState from "../../../components/EmptyState";
import { Tooltip,  Divider,
  IconButton,
  Menu,
  MenuItem,
  Button,
  DialogActions,
  Checkbox, } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import LinkButton from "../../../components/LinkButton";
import Card from "../../../components/Card";
import CustomButton from "../../../components/CustomButton";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Layout from "../../../layout";
import ViewDetails from "../Home/Modal/ViewDetails";
import { getCountryAction } from "../../../redux/actions/countryActions";
import { getIndustryAction } from "../../../redux/actions/industryActions";
import { PropTypes, func, object, string } from "prop-types";
import { CURRENCY_OPTIONS } from "../../../utils/constants";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import CustomInput from "../../../components/CustomInput";
import CustomSelect from "../../../components/CustomSelect";
import CustomTextArea from "../../../components/CustomTextArea";

import { FormControl, Select, TextField } from "@material-ui/core";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import {
  getAllSkillsAction,
  createCategorySkillAction,
} from "../../../redux/actions/skillsAction";
import SearchLocationInput from "../../../components/LocationComponent";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  InputLabel,
} from "@material-ui/core";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
} from "react-share";
import { encodeShortPayload } from "../ShortRedirect";
import cogoToast from "cogo-toast";
import axiosSetup from "../../../ajax";
import "./index.scss";
import moment from "moment";

/*TODO:: Refactor this Page later -- tight deadlines*/

const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    ["link", "image", "video"],
    ["blockquote"],
    ["clean"],
  ],
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
  "blockquote",
];
const stripHtmlTags = (html = "") => html.replace(/<[^>]+>/g, " ");
const getJobExcerpt = (html = "", limit = 160) => {
  const textOnly = stripHtmlTags(html).replace(/\s+/g, " ").trim();
  if (!textOnly) return "";
  return textOnly.length > limit
    ? `${textOnly.slice(0, limit).trim()}…`
    : textOnly;
};

const jobExcerptStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  minHeight: "3.75rem",
  lineHeight: "1.35rem",
};

const getBaseWebUrl = () => {
  if (process.env.REACT_APP_WEB_URL) return process.env.REACT_APP_WEB_URL;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
};

const getShortReferralLink = (job) => {
  if (!job || !job.id || !job.created_by_profile?.refCode) return "";

  const baseUrl = getBaseWebUrl();
  if (!baseUrl) return "";

  const payload = {
    jobId: job.id,
    refCode: job.created_by_profile.refCode,
  };

  if (job.company_id) {
    payload.companyId = job.company_id;
  }

  const code = encodeShortPayload(payload);
  return `${baseUrl}/r/${code}`;
};

const getShortInviteLink = (job) => {
  if (!job || !job.id || !job.created_by_profile?.refCode) return "";

  const baseUrl = getBaseWebUrl();
  if (!baseUrl) return "";

  const payload = {
    jobId: job.id,
    refCode: job.created_by_profile.refCode,
    isInvite: true,
  };

  if (job.company_id) {
    payload.companyId = job.company_id;
  }

  const code = encodeShortPayload(payload);
  return `${baseUrl}/r/${code}`;
};

const getJobDetailUrl = (job) => {
  if (!job || !job.id) return "";

  const baseUrl = getBaseWebUrl();
  if (!baseUrl) return "";

  return `${baseUrl}/job-lists-details/${job.id}/apply/no-ref`;
};

const getShareTitle = (job) => {
  if (!job) return "Job Referral";
  const roleTitle = job.role_title || "this role";
  const companyName = job.company_name || job.campany_name || "";
  return companyName
    ? `Job Referral for ${roleTitle} at ${companyName}`
    : `Job Referral for ${roleTitle}`;
};

const getRelativePostedTime = (date) => {
  if (!date) return "Unknown date";
  return moment(date).fromNow();
};

const MyJobs = () => {
  const [page] = useState(1);
  const dispatch = useDispatch();
  const { jobId } = useParams();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [section, setSection] = useState("details");
  const [subSection, setSubSection] = useState("details");
  const [loading, setLoading] = useState(false);
  const [, setLoadingMore] = useState(false);
  const [open, setOpen] = useState(false);
  const [openInvite, setInviteOpen] = useState(false);
  const [currentJob, setCurrentJob] = useState({});
  const textAreaRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);
  const [deletedJobIds, setDeletedJobIds] = useState([]);
  const [levelOptions, setLevelOptions] = useState({});
  const [industryOptions, setIndustryOptions] = useState({});
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [skillOptions, setSkillOptions] = useState({});
  const [editJobView, setEditJobView] = useState(false);
  const [duplicatedData, setDuplicatedData] = useState(null);

  // AI Loading State
  const [aiLoading, setAiLoading] = useState(false);

  const [campany_name, setcampany_name] = useState();
  const [location, setlocation] = useState();
  const [countryvalue, setcountryvalue] = useState();
  const [no_of_staff, setno_of_staff] = useState();
  const [role_title, setrole_title] = useState();
  const [job_levelvalue, setjob_level] = useState();
  const [reports_to, setreports_to] = useState();
  const [job_type, setjob_type] = useState();
  const [industryvalue, setindustryvalue] = useState();
  const [about_company, setabout_company] = useState();
  const [salary, setsalary] = useState();
  const [duration, setduration] = useState();
  const [salary_range, setsalary_range] = useState();
  const [isCompanyRepresentative, setisCompanyRepresentative] = useState();
  const [canRecruiterRequest, setcanRecruiterRequest] = useState();
  const [company_id, setcompany_id] = useState();
  const [newPost, setNewPost] = useState(false);
  const [isSuspended, setIsSuspended] = useState();
  const [isDraft, setIsDraft] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [jobIdValue, setJobIdValue] = useState("details");
  const [selectedCountry, setSelectedCountry] = useState();
  const [consentChecked, setConsentChecked] = useState(false);
  const [wasPublished, setWasPublished] = useState(false);

  // Filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterTier, setFilterTier] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({
    searchTerm: "",
    status: "",
    tier: "",
  });

  // Estimated salary modal state for Tier 3
  const [showEstimatedSalaryModal, setShowEstimatedSalaryModal] =
    useState(false);
  const [estimatedSalaryData, setEstimatedSalaryData] = useState(null);
  const [isEstimatingSalary, setIsEstimatingSalary] = useState(false);

  const { country, profile, industry, job, skill, auth } = useSelector(
    (store) => store,
  );
  const { countries } = country;
  const { industries } = industry;
  const { jobLevels } = job;
  const { allSkills } = skill;
  const { userData } = auth;

  const [stateRecognition, setStateRecognition] = useState({
    campany_name: "",
    location: "",
    country: "",
    no_of_staff: "",
    role_title: "",
    job_level: "",
    reports_to: "",
    job_type: "",
    industry: "",
    about_company: "",
    salary: "",
    duration: "",
    salary_range: "",
    currency: "",
    isCompanyRepresentative: "",
    canRecruiterRequest: "",
    job_tier: "",
    estimated_views: "",
    worktype: "",
    applicant_benefit: "",
    company_id: 0,
    skills_required: [],
    is_draft: 0,
  });

  useEffect(() => {
    const options = {};
    allSkills.forEach((skill) => (options[skill.title] = skill.title));
    setSkillOptions(allSkills);
  }, [allSkills]);

  useEffect(() => {
    Promise.all([getIndustryAction(dispatch), getJobLevelsAction(dispatch)]);
  }, [dispatch]);

  useEffect(() => {
    const options = {};
    industries &&
      industries.forEach(
        (industry) => (options[industry.title] = industry.title),
      );
    setIndustryOptions(options);
  }, [industries]);

  useEffect(() => {
    const promises = [getCountryAction(dispatch)];
  }, [dispatch]);

  useEffect(() => {
    if (copied) {
      cogoToast.success("Link copied");
      setCopied(false);
    }
  }, [copied]);

  useEffect(() => {
    if (!editJobView) {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }, [editJobView]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { myJobs } = useSelector(({ job }) => job);
  const jobs = myJobs;

  // Client-side filtering logic
  const filteredJobs = jobs
    ? jobs.filter((job) => {
        const jobId = String(job.id);
        // Filter out deleted jobs
        if (deletedJobIds.some((deletedId) => String(deletedId) === jobId)) {
          return false;
        }

        // Apply search term filter
        if (appliedFilters.searchTerm) {
          const searchLower = appliedFilters.searchTerm.toLowerCase();
          const roleTitle = (job.role_title || "").toLowerCase();
          const companyName = (
            job.campany_name ||
            job.company_name ||
            ""
          ).toLowerCase();
          const location = (job.location || "").toLowerCase();

          if (
            !roleTitle.includes(searchLower) &&
            !companyName.includes(searchLower) &&
            !location.includes(searchLower)
          ) {
            return false;
          }
        }

        // Apply status filter
        if (appliedFilters.status) {
          const status = appliedFilters.status;

          // Check for tier filters
          if (status === "tier1" && job.job_tier != 1) return false;
          if (status === "tier2" && job.job_tier != 2) return false;
          if (status === "tier3" && job.job_tier != 3) return false;

          // Check for draft/published status
          if (status === "draft" && job.is_draft != 1 && job.is_draft != "1")
            return false;
          if (
            status === "published" &&
            job.is_draft != 0 &&
            job.is_draft != "0"
          )
            return false;

          // Check for suspension status
          if (status === "active" && job.isSuspended == "1") return false;
          if (status === "hold" && job.isSuspended != "1") return false;
        }

        // Apply tier filter
        if (appliedFilters.tier) {
          if (Number(job.job_tier) !== Number(appliedFilters.tier)) {
            return false;
          }
        }

        return true;
      })
    : [];

  useEffect(() => {
    page === 1 ? setLoading(true) : setLoadingMore(true);
    Promise.resolve(getMyJobsAction(dispatch, page)).finally(() =>
      page === 1 ? setLoading(false) : setLoadingMore(false),
    );
  }, [dispatch, page]);

  useEffect(() => {
    if (stateRecognition && stateRecognition.is_draft !== undefined) {
      const isDraft = stateRecognition.is_draft;
      const published = isDraft === 0 || isDraft === "0" || isDraft === false;
      console.log(
        "MyJobs - stateRecognition.is_draft:",
        isDraft,
        "type:",
        typeof isDraft,
        "wasPublished:",
        published,
      );
      setWasPublished(published);
    }
  }, [stateRecognition.is_draft]);

  useEffect(() => {
    const options = {};
    jobLevels &&
      jobLevels.forEach((level) => (options[level.id] = level.title));
    setLevelOptions(options);
  }, [jobLevels]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setSection("details");
    setAnchorEl(null);
    setOpen(false);
  };

  const handleEditJob = (job) => {
    history.push(`/editjob/${job.id}`);
  };

  const viewJobDetails = () => {
    setSection("details");
    setSubSection("details");
  };

  const viewDocument = () => {
    setSection("details");
    setSubSection("documents");
  };

  const handleInviteClose = () => {
    setSection("details");
    setAnchorEl(null);
    setInviteOpen(false);
  };

  const openDetails = (job) => {
    setCurrentJob(job);
    setSection("details");
    setOpen(true);
  };

  const openInviteDetails = (job) => {
    setCurrentJob(job);
    setSection("details");
    setInviteOpen(true);
  };

  const copyToClipboard = () => {
    if (!textAreaRef.current) return;
    textAreaRef.current.select();
    document.execCommand("copy");
    setCopied(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStateRecognition((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Estimate salary for Tier 3 jobs
  const estimateSalaryForTier3 = async () => {
    const roleTitle = stateRecognition.role_title;
    const location = stateRecognition.location;
    const industry = stateRecognition.industry;
    const country = stateRecognition.country;

    if (!roleTitle || !location || !industry || industry === "0") {
      cogoToast.error(
        "Please fill in Role Title, Location, and Industry to estimate salary",
      );
      return null;
    }

    try {
      const params = new URLSearchParams({
        type: "1",
        role_title: roleTitle,
        location,
        industry: industry || "",
        country: String(country || ""),
      });
      if (stateRecognition?.salary_range) params.append("salary_range", stateRecognition.salary_range);
      if (stateRecognition?.duration) params.append("duration", stateRecognition.duration);
      if (stateRecognition?.currency) params.append("currency", stateRecognition.currency);

      const response = await axiosSetup(
        "get",
        `/jobs/estimate-salary?${params.toString()}`,
      );

      const data = response.data?.data || response.data;

      if (
        data &&
        data.estimated_annual_salary !== undefined &&
        data.estimated_annual_salary !== null
      ) {
        const estimatedSalary = data.estimated_annual_salary;
        const currency = data.currency || data.currency_code || "USD";

        return {
          estimated_salary: estimatedSalary,
          currency: String(currency).toUpperCase(),
          formatted_salary: estimatedSalary.toLocaleString("en-US"),
        };
      } else {
        cogoToast.error(
          "Salary estimation service is currently unavailable. Please try again later.",
        );
        return null;
      }
    } catch (error) {
      const status = error?.response?.status;
      const msg =
        status === 500
          ? "Salary estimation service is currently unavailable. Please try again later."
          : "Error estimating salary. Please try again.";
      cogoToast.error(msg);
      return null;
    }
  };

  const submitJobWithEstimatedSalary = async () => {
    setShowEstimatedSalaryModal(false);
    setIsUpdating(true);

    const { estimated_views: _, ...jobDataWithoutEstimatedViews } =
      stateRecognition;

    delete jobDataWithoutEstimatedViews.salary;

    const payload = {
      id: currentJob.id,
      ...jobDataWithoutEstimatedViews,
      skills_required: selectedSkills,
      is_draft: isDraft ? 1 : 0,
      estimated_salary: estimatedSalaryData.estimated_salary,
    };

    try {
      const response = await editJobAction(dispatch, payload);

      if (response?.payload) {
        const updatedJob = response.payload;
        setCurrentJob((prev) => ({ ...prev, ...updatedJob }));
        setStateRecognition((prev) => ({ ...prev, ...updatedJob }));
        setSelectedSkills(updatedJob.skills_required || []);
        setIsDraft(Boolean(updatedJob.is_draft));

        // ADD SUCCESS TOAST HERE
        cogoToast.success("Job updated and published successfully!");
      }

      await getMyJobsAction(dispatch, page);
      setEstimatedSalaryData(null);
      window.scrollTo(0, 0);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error(error);
      cogoToast.error("Failed to update job. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };
  const handleUpdateSubmit = async (e, shouldBeDraft = isDraft) => {
    e.preventDefault();

    if (shouldBeDraft) {
      if (!stateRecognition.campany_name || !stateRecognition.role_title) {
        cogoToast.error(
          "Please fill in Company Name and Role Title to save as draft",
        );
        return;
      }
    } else {
      // Required fields for publishing
      const requiredFields = [
        { field: "campany_name", name: "Company Name" },
        { field: "role_title", name: "Role Title" },
        { field: "location", name: "Location" },
        { field: "industry", name: "Industry" },
        { field: "job_level", name: "Job Level" },
        { field: "job_type", name: "Job Type" },
        { field: "country", name: "Country" },
        { field: "job_tier", name: "Job Tier" },
      ];

      for (const { field, name } of requiredFields) {
        if (
          !stateRecognition[field] ||
          stateRecognition[field] === "0" ||
          stateRecognition[field] === ""
        ) {
          cogoToast.error(`Please fill in ${name}`);
          return;
        }
      }

      if (!selectedSkills || selectedSkills.length === 0) {
        cogoToast.error("Please add at least one skill");
        return;
      }

      const job_tier = parseInt(stateRecognition.job_tier, 10);

      // Check consent for Tier 2 and 3 before proceeding
      if ((job_tier === 2 || job_tier === 3) && !consentChecked) {
        cogoToast.error("Please accept the terms of use to publish");
        return;
      }
    }

    const job_tier = parseInt(stateRecognition.job_tier, 10);

    if (job_tier === 3 && !shouldBeDraft) {
      setIsEstimatingSalary(true);
      const salaryData = await estimateSalaryForTier3();
      setIsEstimatingSalary(false);

      if (salaryData) {
        setEstimatedSalaryData(salaryData);
        setShowEstimatedSalaryModal(true);
      }
      return;
    }

    let estimated_views = null;
    if (job_tier === 2 && stateRecognition.estimated_views) {
      if (!shouldBeDraft) {
        if (isNaN(parseInt(stateRecognition.estimated_views, 10))) {
          cogoToast.error("Please enter a valid number for Estimated Views");
          return;
        }
        estimated_views = parseInt(stateRecognition.estimated_views, 10);
        if (estimated_views < 1) {
          cogoToast.error("Estimated Views must be at least 1");
          return;
        }
      } else {
        estimated_views = stateRecognition.estimated_views;
      }
    }

    try {
      setIsUpdating(true);

      const { estimated_views: _, ...jobDataWithoutEstimatedViews } =
        stateRecognition;

      if (jobDataWithoutEstimatedViews.salary) {
        delete jobDataWithoutEstimatedViews.salary;
      }

      const payload = {
        id: currentJob.id,
        ...jobDataWithoutEstimatedViews,
        skills_required: selectedSkills,
        is_draft: shouldBeDraft ? 1 : 0,
      };

      if (job_tier === 2 && estimated_views) {
        payload.estimated_views = estimated_views;
      }

      const response = await editJobAction(dispatch, payload);

      if (response?.payload) {
        const updatedJob = response.payload;
        setCurrentJob((prev) => ({ ...prev, ...updatedJob }));
        setStateRecognition((prev) => ({ ...prev, ...updatedJob }));
        setSelectedSkills(updatedJob.skills_required || []);
        setIsDraft(Boolean(updatedJob.is_draft));

        // ADD SUCCESS TOAST HERE
        if (shouldBeDraft) {
          cogoToast.success("Job saved as draft successfully!");
        } else {
          cogoToast.success("Job updated and published successfully!");
        }
      }

      await getMyJobsAction(dispatch, page);
      window.scrollTo(0, 0);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error(error);
      cogoToast.error("Failed to update job. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };

  const handleDelete = (jobid) => {
    setJobToDelete(jobid);
    setDeleteConfirmOpen(true);
    setAnchorEl(null);
  };

  const confirmDelete = async () => {
    if (!jobToDelete) return;

    setLoading(true);
    setDeleteConfirmOpen(false);

    setDeletedJobIds((prev) => [...prev, jobToDelete]);

    try {
      const response = await deleteJob(dispatch, jobToDelete);

      if (response && response.type === "ERROR") {
        setDeletedJobIds((prev) =>
          prev.filter((id) => String(id) !== String(jobToDelete)),
        );
        cogoToast.error(response.payload || "Failed to delete job");
        setLoading(false);
        setJobToDelete(null);
        return;
      }

      await getMyJobsAction(dispatch, page);
      // cogoToast.success("Job deleted successfully");

      setTimeout(() => {
        setDeletedJobIds((prev) =>
          prev.filter((id) => String(id) !== String(jobToDelete)),
        );
      }, 300);
    } catch (error) {
      console.log(error);
      setDeletedJobIds((prev) =>
        prev.filter((id) => String(id) !== String(jobToDelete)),
      );
      cogoToast.error("Failed to delete job");
    } finally {
      setLoading(false);
      setJobToDelete(null);
    }
  };

  const cancelDelete = () => {
    setDeleteConfirmOpen(false);
    setJobToDelete(null);
  };

  const handleCloseJob = async (jobid) => {
    setLoading(true);
    setAnchorEl(null);

    try {
      const response = await closeJob(dispatch, jobid);
      if (response) {
        await getMyJobsAction(dispatch, page);
      }
    } catch (error) {
      console.log(error);
      cogoToast.error("Failed to update job status");
    } finally {
      setLoading(false);
    }
  };

  const handleSuspend = async (jobid) => {
    setLoading(true);
    setAnchorEl(null); // Close the menu immediately

    try {
      const response = await suspendJob(dispatch, jobid);
      if (response) {
        // Refresh jobs list to update the card status immediately
        await getMyJobsAction(dispatch, page);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const extractEntityId = (value) => {
    if (!value) {
      return "";
    }
    if (typeof value === "object") {
      return value.id || value.value || value.code || "";
    }
    return value;
  };

  const normalizeDuplicateSkills = (jobData) => {
    let skillsSource = [];

    if (
      Array.isArray(jobData.skills_required) &&
      jobData.skills_required.length
    ) {
      skillsSource = jobData.skills_required;
    } else if (Array.isArray(jobData.skills) && jobData.skills.length) {
      skillsSource = jobData.skills;
    }

    return skillsSource
      .map((skill) => {
        if (!skill) return "";
        if (typeof skill === "string") return skill;
        if (typeof skill === "object") {
          return skill.title || skill.name || skill.label || "";
        }
        return "";
      })
      .filter(Boolean);
  };

  const handleDuplicateJob = (jobData) => {
    if (!jobData) return;

    const duplicatePayload = {
      campany_name: jobData.campany_name || jobData.company_name || "",
      industry: extractEntityId(jobData.industry) || jobData.industry || "",
      about_company: jobData.about_company || "",
      no_of_staff: jobData.no_of_staff || "",
      job_level: extractEntityId(jobData.job_level) || jobData.job_level || "",
      role_title: jobData.role_title || "",
      job_type: extractEntityId(jobData.job_type) || jobData.job_type || "",
      reports_to: jobData.reports_to || "",
      applicant_benefit: jobData.applicant_benefit || "salary",
      skills_required: normalizeDuplicateSkills(jobData),
      location: jobData.location || "",
      additional_files: Array.isArray(jobData.additional_files)
        ? jobData.additional_files
        : [],
      isToRefTimeLineOrToHireRecruter:
        jobData.isToRefTimeLineOrToHireRecruter || "1",
      isCompanyRepresentative:
        jobData.isCompanyRepresentative ??
        stateRecognition.isCompanyRepresentative ??
        "1",
      salary: jobData.salary || "",
      duration: jobData.duration || "",
      canRecruiterRequest:
        jobData.canRecruiterRequest ??
        stateRecognition.canRecruiterRequest ??
        "0",
      country: extractEntityId(jobData.country) || jobData.country || "",
      job_tier: jobData.job_tier || "",
      estimated_views: jobData.estimated_views || jobData.views_left || "",
      worktype: jobData.worktype || jobData.work_type || "1",
      salary_range: jobData.salary_range || "",
      currency: jobData.currency || jobData.salary_currency || "",
      is_draft: jobData.is_draft || "0",
    };

    setDuplicatedData(duplicatePayload);
    setNewPost(true);
    setAnchorEl(null);
  };

  const handleDuplicateClose = () => {
    setNewPost(false);
    setDuplicatedData(null);
  };

  const handleChangeCountry = ({ target: { value } }) => {
    const countryID = value;
    setSelectedCountry(countryID);
    setStateRecognition({ ...stateRecognition, country: countryID });
  };

  const addSkill = ({ target: { value } }) => {
    const skills = value;
    setSelectedSkills(skills);
    handleChange({ target: { value: skills, name: "skills_required" } });
  };

  const displaySkills = () => {
    return selectedSkills.map((skill, index) => (
      <span
        className="d-flex align-items-center justify-content-between mt-2 mr-2 py-1 pl-3 outlined"
        key={index.toString()}
      >
        {skill}
        <IconButton onClick={() => removeSkill(skill)}>
          <svg width="10" height="8">
            <use href={`${icons}#close-blue`}></use>
          </svg>
        </IconButton>
      </span>
    ));
  };

  const removeSkill = (skillToRemove) => {
    const skillArray = [...selectedSkills];
    const newSkillArray = skillArray.filter((skill) => skill !== skillToRemove);
    setSelectedSkills(newSkillArray);
  };

  const [inputValue, setInputValue] = useState("");

  const handleSkillsChange = (_event, value, reason) => {
    // Prevent clearing all skills when clicking the X button
    if (reason === "clear") {
      setInputValue("");
      return;
    }

    const normalized = value.map((v) =>
      typeof v === "string" ? v : v?.inputValue ? v.inputValue : v?.title || v,
    );
    setSelectedSkills(normalized);
    setInputValue("");
    handleChange({ target: { value: normalized, name: "skills_required" } });
    const existingTitles = new Set(
      (skillOptions || []).map(({ title }) => (title || "").toLowerCase()),
    );
    const newTitles = normalized
      .map((t) => (t || "").trim())
      .filter((t) => t && !existingTitles.has(t.toLowerCase()));
    if (newTitles.length > 0) {
      Promise.all(
        newTitles.map((title) =>
          createCategorySkillAction({ title, description: title }, dispatch),
        ),
      ).then(() => getAllSkillsAction(dispatch));
    }
  };

  const hashtags = ["workbrook", "job", "workbrookjobs"];
  const currentJobReferralLink =
    getShortInviteLink(currentJob) || getJobDetailUrl(currentJob);

  return (
    <Layout
      isOnDuplicatePost={newPost}
      duplicatedDataValue={duplicatedData}
      onDuplicateClose={handleDuplicateClose}
    >
      {/** Edit Job component */}
      {editJobView ? (
        <div
          style={{
            backgroundColor: "#fff",
            padding: 20,
          }}
        >
          <form onSubmit={handleUpdateSubmit}>
            <h2>Edit Job</h2>
            <div className="row mx-0">
              <div className="col-12 col-md-6">
                <CustomInput
                  type="text"
                  onChange={handleChange}
                  name="campany_name"
                  value={stateRecognition.campany_name}
                  placeholder=""
                  label="Name Of Company"
                  id="campany_name"
                />
              </div>

              <div className="col-12 col-md-6">
                <FormControl
                  variant="outlined"
                  fullWidth
                  className="w-100 mb-4 rounded"
                >
                  <SearchLocationInput
                    inputStyle="TextField"
                    value={stateRecognition.location}
                    handleLocationChange={(e) =>
                      handleChange({ target: { value: e, name: "location" } })
                    }
                  />
                </FormControl>
              </div>

              <div className="col-12 col-md-6" style={{ marginTop: "-5px" }}>
                <CustomSelect
                  handleChange={handleChange}
                  className="fullwidth-select"
                  options={{
                    0: "Select Staff Strength",
                    "Sole Employee": "Sole Employee",
                    "2-20": "2-20",
                    "21-50": "21-50",
                    "51-200": "51-200",
                    "201-500": "201-500",
                    "501-1000": "501-1000",
                    "1,001-10,000": "1,001-10,000",
                    "10,001-50,000": "10,001-50,000",
                    "50,001+": "50,001+",
                  }}
                  id="no_of_staff"
                  name="no_of_staff"
                  label="Staff Strength"
                  currentValue={stateRecognition.no_of_staff}
                />
              </div>

              <div className="col-12 col-md-6">
                <CustomInput
                  type="text"
                  onChange={handleChange}
                  name="role_title"
                  value={stateRecognition.role_title}
                  label="Role title"
                  id="role_title"
                />
              </div>

              <div className="col-12 col-md-6">
                <CustomInput
                  type="text"
                  onChange={handleChange}
                  name="reports_to"
                  value={stateRecognition.reports_to}
                  label="Reports To"
                  id="reports_to"
                />
              </div>

              <div className="col-12 col-md-6" style={{ marginTop: "-4px" }}>
                <CustomSelect
                  handleChange={handleChange}
                  options={{ 0: "Select Level", ...levelOptions }}
                  id="job_level"
                  name="job_level"
                  label="Job Levels"
                  currentValue={stateRecognition.job_level}
                />
              </div>

              <div className="col-12 col-md-6">
                <CustomSelect
                  handleChange={handleChange}
                  options={{
                    0: "Select Type",
                    "part-time": "Part-time",
                    "full-time": "Full-time",
                    contract: "Contract",
                    internship: "Internship",
                    volunteer: "Volunteer",
                  }}
                  id="job_type"
                  name="job_type"
                  label="Type of Employment"
                  currentValue={stateRecognition.job_type}
                />
              </div>

              <div className="col-12 col-md-6">
                <CustomSelect
                  handleChange={handleChange}
                  options={{ 0: "Select an Industry", ...industryOptions }}
                  id="industry"
                  name="industry"
                  label="Industry"
                  currentValue={stateRecognition.industry}
                />
              </div>

              <div className="col-12 col-md-6">
                <CustomSelect
                  handleChange={handleChange}
                  options={{
                    0: "Select an Job Option",
                    1: "Hybrid",
                    2: "Remote",
                    3: "On Site",
                  }}
                  id="worktype"
                  name="worktype"
                  label="Work Type"
                  currentValue={stateRecognition.worktype}
                />
              </div>

              <div className="col-12 col-md-6" style={{ marginTop: "18px" }}>
                <InputLabel name="country-label mt-3">
                  Select Country
                </InputLabel>
                <Select
                  labelId="country"
                  name="country"
                  label="country"
                  value={stateRecognition.country}
                  onChange={handleChangeCountry}
                  className="fullwidth-select"
                >
                  <MenuItem value="">Select a Country</MenuItem>
                  {countries.map(({ name, id }) => (
                    <MenuItem key={id} value={id}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <div className="col-12 col-md-6" style={{ marginTop: "-4px" }}>
                <CustomSelect
                  handleChange={handleChange}
                  options={(() => {
                    const baseOptions = {
                      0: "Select Job Tier",
                      1: "Tier 1",
                      2: "Tier 2",
                    };

                    // Only include Tier 3 if user has canPostTier3 permission
                    if (userData && userData.canPostTier3 === "1") {
                      baseOptions[3] = "Tier 3";
                    }

                    return baseOptions;
                  })()}
                  id="job_tier"
                  name="job_tier"
                  label="Job Tier"
                  currentValue={stateRecognition.job_tier}
                />
              </div>

              {stateRecognition.job_tier === "2" && (
                <div className="col-12 col-md-6">
                  <CustomInput
                    type="number"
                    onChange={handleChange}
                    name="estimated_views"
                    value={stateRecognition.estimated_views || ""}
                    placeholder="Enter estimated views"
                    label="Estimated Views"
                    id="estimated_views"
                    min="1"
                  />
                  <EstimatedViewsCalculation
                    views={stateRecognition.estimated_views}
                    selectedCountry={stateRecognition.country}
                  />
                </div>
              )}
              
              {/* About Hiring Manager Section */}
              <div className="col-12 col-md-12">
                <br />
                <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                  <label style={{ fontWeight: "500", margin: 0 }}>
                    About Hiring Manager
                  </label>
                  <Tooltip
                    title="A short note about the hiring manager gives candidates clarity on who they'll work with, builds trust, and attracts better aligned applicants. It turns your job post from a list of tasks into a real opportunity."
                    placement="top"
                    arrow
                  >
                    <HelpOutlineIcon
                      style={{
                        fontSize: "18px",
                        marginLeft: "6px",
                        color: "#6c757d",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </div>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  variant="outlined"
                  name="about_hiring_manager"
                  value={stateRecognition.about_hiring_manager || ""}
                  onChange={handleChange}
                  placeholder="A short note about the hiring manager builds trust and attracts better aligned candidates by showing who leads the role."
                  helperText={`${(stateRecognition.about_hiring_manager || "").length}/500 characters`}
                  inputProps={{ maxLength: 500 }}
                  style={{ marginBottom: "16px" }}
                />
              </div>

              <div className="col-12 col-md-12">
                <br />
                <label
                  style={{
                    fontWeight: "500",
                    marginBottom: "8px",
                    display: "block",
                  }}
                >
                  About Company/Role
                </label>
                <div style={{ position: "relative" }}>
                  <style>
                    {`
        .custom-quill-editor {
          background: white;
          border-radius: 8px;
          position: relative;
        }

        .custom-quill-editor .ql-toolbar {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          background-color: #f8f9fa;
          border: 1px solid #d1d5db;
          border-bottom: none;
          padding: 12px;
        }

        .custom-quill-editor .ql-container {
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          border: 1px solid #d1d5db;
          font-family: inherit;
          position: relative;
        }

        .custom-quill-editor .ql-editor {
          min-height: 320px;
          font-size: 15px;
          line-height: 1.6;
          color: #000000;
          text-align: left !important;
        }

        /* Force left alignment for all elements */
        .custom-quill-editor .ql-editor h1,
        .custom-quill-editor .ql-editor h2,
        .custom-quill-editor .ql-editor h3,
        .custom-quill-editor .ql-editor p,
        .custom-quill-editor .ql-editor ul,
        .custom-quill-editor .ql-editor ol {
          text-align: left !important;
        }

        /* Black bullets and numbers */
        .custom-quill-editor .ql-editor ul li::before {
          color: #000000 !important;
        }

        .custom-quill-editor .ql-editor ol li::before {
          color: #000000 !important;
        }

        .custom-quill-editor .ql-editor ul li,
        .custom-quill-editor .ql-editor ol li {
          color: #000000 !important;
        }

        .custom-quill-editor .ql-editor p {
          color: #000000;
          margin-bottom: 0.8em;
        }

        .custom-quill-editor .ql-editor.ql-blank::before {
          color: #9ca3af;
          font-style: italic;
        }

        /* Headings */
        .custom-quill-editor .ql-editor h1 {
          font-size: 2em;
          font-weight: bold;
          color: #000000;
          margin: 0.67em 0;
        }

        .custom-quill-editor .ql-editor h2 {
          font-size: 1.5em;
          font-weight: bold;
          color: #000000;
          margin: 0.75em 0;
        }

        .custom-quill-editor .ql-editor h3 {
          font-size: 1.17em;
          font-weight: bold;
          color: #000000;
          margin: 0.83em 0;
        }

        /* Fix link tooltip styling - POSITIONED INSIDE EDITOR */
        .custom-quill-editor .ql-tooltip {
          position: absolute !important;
          left: 50% !important;
          top: 50% !important;
          transform: translate(-50%, -50%) !important;
          background-color: #fff !important;
          border: 1px solid #0d6efd !important;
          box-shadow: 0 4px 12px rgba(13, 110, 253, 0.25) !important;
          padding: 16px 20px !important;
          border-radius: 8px !important;
          z-index: 1000 !important;
          min-width: 400px !important;
        }

        .custom-quill-editor .ql-tooltip input[type=text] {
          border: 1px solid #0d6efd !important;
          padding: 10px 14px !important;
          border-radius: 6px !important;
          font-size: 14px !important;
          width: 280px !important;
          margin-right: 8px !important;
          color: #000 !important;
        }

        .custom-quill-editor .ql-tooltip input[type=text]:focus {
          border-color: #0d6efd !important;
          outline: none !important;
          box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.2) !important;
        }

        .custom-quill-editor .ql-tooltip a.ql-action,
        .custom-quill-editor .ql-tooltip a.ql-remove {
          padding: 8px 18px !important;
          background-color: #0d6efd !important;
          color: #fff !important;
          border-radius: 6px !important;
          text-decoration: none !important;
          display: inline-block !important;
          margin-left: 6px !important;
          font-weight: 500 !important;
          transition: background-color 0.2s !important;
        }

        .custom-quill-editor .ql-tooltip a.ql-action:hover {
          background-color: #0b5ed7 !important;
        }

        .custom-quill-editor .ql-tooltip a.ql-remove {
          background-color: #dc3545 !important;
        }

        .custom-quill-editor .ql-tooltip a.ql-remove:hover {
          background-color: #bb2d3b !important;
        }

        .custom-quill-editor .ql-tooltip a.ql-action::after {
          content: 'Save' !important;
          border: none !important;
          margin: 0 !important;
        }

        .custom-quill-editor .ql-tooltip a.ql-remove::before {
          content: 'Remove' !important;
          margin: 0 !important;
        }

        .custom-quill-editor .ql-tooltip::before {
          content: 'Enter link:' !important;
          margin-right: 8px !important;
          color: #374151 !important;
          font-weight: 600 !important;
          display: block !important;
          margin-bottom: 8px !important;
        }

        /* Blue accent color for toolbar */
        .custom-quill-editor .ql-snow.ql-toolbar button:hover,
        .custom-quill-editor .ql-snow .ql-toolbar button:hover,
        .custom-quill-editor .ql-snow.ql-toolbar button.ql-active,
        .custom-quill-editor .ql-snow .ql-toolbar button.ql-active,
        .custom-quill-editor .ql-snow.ql-toolbar .ql-picker-label:hover,
        .custom-quill-editor .ql-snow .ql-toolbar .ql-picker-label:hover,
        .custom-quill-editor .ql-snow.ql-toolbar .ql-picker-label.ql-active,
        .custom-quill-editor .ql-snow .ql-toolbar .ql-picker-label.ql-active {
          color: #0d6efd !important;
        }

        .custom-quill-editor .ql-snow.ql-toolbar button:hover .ql-stroke,
        .custom-quill-editor .ql-snow .ql-toolbar button:hover .ql-stroke,
        .custom-quill-editor .ql-snow.ql-toolbar button.ql-active .ql-stroke,
        .custom-quill-editor .ql-snow .ql-toolbar button.ql-active .ql-stroke {
          stroke: #0d6efd !important;
        }

        .custom-quill-editor .ql-snow.ql-toolbar button:hover .ql-fill,
        .custom-quill-editor .ql-snow .ql-toolbar button:hover .ql-fill,
        .custom-quill-editor .ql-snow.ql-toolbar button.ql-active .ql-fill,
        .custom-quill-editor .ql-snow .ql-toolbar button.ql-active .ql-fill {
          fill: #0d6efd !important;
        }

        /* Blockquote - Blue */
        .custom-quill-editor .ql-editor blockquote {
          border-left: 4px solid #0d6efd;
          padding-left: 16px;
          margin-left: 0;
          font-style: italic;
          color: #555555;
        }

        /* Links - Blue */
        .custom-quill-editor .ql-editor a {
          color: #0d6efd;
          text-decoration: underline;
        }

        /* Focus state - Blue */
        .custom-quill-editor .ql-container.ql-snow:focus-within {
          border-color: #0d6efd;
          box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.15);
        }

        /* Video embed styling */
        .custom-quill-editor .ql-editor iframe {
          max-width: 100%;
          border-radius: 8px;
          margin: 1em 0;
        }

        .custom-quill-editor .ql-video {
          width: 100%;
          height: 400px;
        }

        /* Hide the default arrow on tooltip */
        .custom-quill-editor .ql-tooltip[data-mode=link]::before {
          display: none !important;
        }

        .custom-quill-editor .ql-tooltip.ql-editing {
          left: 50% !important;
          transform: translateX(-50%) !important;
        }
      `}
                  </style>
                  <ReactQuill
                    className="custom-quill-editor"
                    theme="snow"
                    value={stateRecognition.about_company || ""}
                    onChange={(content) => {
                      setStateRecognition({
                        ...stateRecognition,
                        about_company: content,
                      });
                    }}
                    modules={quillModules}
                    formats={quillFormats}
                    placeholder="Write about the company and role..."
                  />
                </div>
              </div>
              <div className="col-12 col-md-12">
                <SalaryRangeRow
                  handleChange={handleChange}
                  salary_range={stateRecognition.salary_range}
                  duration={stateRecognition.duration}
                  currency={stateRecognition.currency}
                />
              </div>

              <div className="col-12 col-md-6" style={{ marginTop: "18px" }}>
                <FormControl variant="outlined" fullWidth className="w-100">
                  <Autocomplete
                    disableClearable
                    multiple
                    freeSolo
                    id="skills"
                    options={(skillOptions || []).map(({ title }) => title)}
                    value={selectedSkills}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason !== "reset") {
                        setInputValue(newInputValue);
                      }
                    }}
                    onChange={handleSkillsChange}
                    filterSelectedOptions
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    filterOptions={(options, params) => {
                      const filter = createFilterOptions();
                      return filter(options, params);
                    }}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option?.title || ""
                    }
                    renderOption={(option) =>
                      typeof option === "string" ? option : option?.title || ""
                    }
                    renderTags={() => null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Skills"
                        placeholder="Add Skill (ex: Interior Design)"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            e.stopPropagation();
                          }
                        }}
                      />
                    )}
                  />
                </FormControl>
                <div className="skills-count mt-3 d-flex align-items-center">
                  <span className="blob rounded px-2 py-1 bg-green co-white">
                    <b>{selectedSkills.length}</b>
                  </span>
                  <span className="ml-2 co-green medium-text">
                    Skills count
                  </span>
                </div>
                {selectedSkills.length > 0 && (
                  <div className="mt-5 w-100 d-flex flex-wrap">
                    {displaySkills()}
                  </div>
                )}
              </div>

              <div className="col-12" style={{ marginTop: "5.5%" }}>
                <RadioGroup
                  name="isCompanyRepresentative"
                  value={stateRecognition.isCompanyRepresentative}
                  onChange={handleChange}
                >
                  <label>Are you a company representative?</label>
                  <div className="d-flex">
                    <FormControlLabel
                      value="1"
                      control={<Radio color="primary" />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio color="primary" />}
                      label="No"
                    />
                  </div>
                </RadioGroup>
              </div>

              {(stateRecognition.job_tier == 2 ||
                stateRecognition.job_tier == 3) && (
                <div
                  className="col-12"
                  style={{ marginTop: "20px", marginBottom: "10px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={consentChecked}
                        onChange={(e) => setConsentChecked(e.target.checked)}
                        name="financialConsent"
                        color="primary"
                        required
                        style={{
                          padding: "9px",
                          marginRight: "8px",
                        }}
                      />
                    }
                    label={
                      <span
                        style={{
                          fontSize: "14px",
                          lineHeight: "1.5",
                          color: "#333",
                        }}
                      >
                        I consent that I have read the{" "}
                        <a
                          href="https://workbrook.com/apps-term-of-use/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#4DABF7",
                            textDecoration: "none",
                            fontWeight: "600",
                            borderBottom: "1px solid #4DABF7",
                            marginRight: "4px",
                          }}
                        >
                          terms of use
                        </a>
                        and understand the financial implication of this post
                      </span>
                    }
                    style={{
                      marginLeft: 0,
                      display: "flex",
                      alignItems: "center",
                    }}
                    labelPlacement="end"
                  />
                </div>
              )}

              <div
                className="d-flex mt-4 justify-content-between"
                style={{ gap: "16px" }}
              >
                <CustomButton
                  type="button"
                  backgroundColor="#6c757d"
                  color="#fff"
                  text="Cancel"
                  handleClick={() => {
                    setEditJobView(false);
                    setAnchorEl(null);
                    window.scrollTo(0, 0);
                  }}
                  additionalClass="mt-2"
                  style={{
                    padding: "14px 24px",
                    flex: wasPublished === false ? "1" : "0 0 30%",
                    minWidth: "120px",
                    fontSize: "15px",
                    fontWeight: "500",
                  }}
                />

                {wasPublished === false && (
                  <CustomButton
                    type="button"
                    backgroundColor="#6c757d"
                    color="#fff"
                    text={isUpdating && isDraft ? "Saving..." : "Save as Draft"}
                    handleClick={(e) => {
                      setIsDraft(true);
                      handleUpdateSubmit(e, true);
                    }}
                    additionalClass="mt-2"
                    disabled={isUpdating || isEstimatingSalary}
                    style={{
                      padding: "14px 24px",
                      flex: "1",
                      minWidth: "140px",
                      fontSize: "15px",
                      fontWeight: "500",
                    }}
                  />
                )}

                <CustomButton
                  type="button"
                  backgroundColor="#41B883"
                  color="#fff"
                  text={
                    isEstimatingSalary
                      ? "Fetching Salary Benchmark..."
                      : isUpdating && !isDraft
                        ? "Publishing..."
                        : "Publish Update"
                  }
                  handleClick={(e) => {
                    setIsDraft(false);
                    handleUpdateSubmit(e, false);
                  }}
                  additionalClass="mt-2"
                  disabled={isUpdating || isEstimatingSalary}
                  style={{
                    padding: "14px 24px",
                    flex: wasPublished === false ? "1" : "0 0 65%",
                    minWidth: "160px",
                    fontSize: "15px",
                    fontWeight: "500",
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      ) : (
        <></>
      )}
      {/** Edit Job component */}

      {!editJobView && (
        <div
          className="d-flex flex-column flex-md-row align-items-stretch mb-4"
          style={{
            padding: "16px",
            backgroundColor: "#f9fafc",
            borderRadius: "12px",
            marginTop: "30px",
            border: "1px solid #e4e9f2",
          }}
        >
          {/* Search Input */}
          <div
            style={{
              flex: 1,
              marginRight: "16px",
              marginBottom: "12px",
            }}
          >
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search by job title, company, or location..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                style: { height: "48px", backgroundColor: "#fff" },
              }}
            />
          </div>

          {/* Status Select */}
          <div
            style={{
              minWidth: "220px",
              marginRight: "16px",
              marginBottom: "12px",
            }}
          >
            <FormControl fullWidth>
              <Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                displayEmpty
                style={{ height: "48px", backgroundColor: "#fff" }}
              >
                <MenuItem value="">All Status</MenuItem>
                <MenuItem value="draft">Draft</MenuItem>
                <MenuItem value="published">Published</MenuItem>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="hold">On Hold</MenuItem>
              </Select>
            </FormControl>
          </div>

          {/* Tier Select (NEW) */}
          <div
            style={{
              minWidth: "200px",
              marginRight: "16px",
              marginBottom: "12px",
            }}
          >
            <FormControl fullWidth>
              <Select
                value={filterTier}
                onChange={(e) => setFilterTier(e.target.value)}
                displayEmpty
                style={{ height: "48px", backgroundColor: "#fff" }}
              >
                <MenuItem value="">All Tiers</MenuItem>
                <MenuItem value="1">Tier 1</MenuItem>
                <MenuItem value="2">Tier 2</MenuItem>
                {userData?.canPostTier3 === "1" && (
                  <MenuItem value="3">Tier 3</MenuItem>
                )}
              </Select>
            </FormControl>
          </div>

          {/* Search Button */}
          <div style={{ minWidth: "120px" }}>
            <CustomButton
              type="button"
              text="Search"
              handleClick={() =>
                setAppliedFilters({
                  searchTerm,
                  status: filterStatus,
                  tier: filterTier,
                })
              }
              style={{
                height: "48px",
                backgroundColor: "#41B883",
                color: "#fff",
                width: "100%",
                fontWeight: 600,
              }}
            />
          </div>
        </div>
      )}

      <div className="row position-relative mt-3 align-items-stretch ">
        {loading && (!filteredJobs || !filteredJobs.length) && (
          <div className="d-flex justify-content-center w-100">
            <SectionLoader />
          </div>
        )}
        {!loading && (!filteredJobs || !filteredJobs.length) && (
          <EmptyState text="There are no jobs posted by you" />
        )}

        {filteredJobs && !editJobView && filteredJobs.length > 0 && (
          <>
            <Menu
              id="profile-menu"
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              PaperProps={{
                style: {
                  width: "15rem",
                  marginTop: "0.2rem",
                  borderRadius: "1rem",
                  boxShadow: "0px 0px 5px -3px rgba(0,0,0,0.2)",
                },
              }}
            >
              <MenuItem
                className="px-4 py-2 medium-text"
                onClick={() => {
                  // Handle job_level: if null or invalid, set to "0" (Select Level)
                  const jobLevelValue = currentJob.job_level
                    ? extractEntityId(currentJob.job_level) || "0"
                    : "0";
                  // Handle job_type: if "0" or null, keep as "0" (Select Type)
                  const jobTypeValue =
                    currentJob.job_type && currentJob.job_type !== "0"
                      ? extractEntityId(currentJob.job_type) ||
                        currentJob.job_type
                      : "0";
                  // Handle industry: if it's a string name, find the matching industry title, otherwise use "0"
                  const industryValue =
                    currentJob.industry && currentJob.industry !== "0"
                      ? currentJob.industry
                      : "0";
                  // Handle duration: convert to string number if it exists
                  const durationValue = currentJob.duration
                    ? String(currentJob.duration)
                    : "0";
                  setStateRecognition({
                    campany_name:
                      currentJob.campany_name || currentJob.company_name || "",
                    location: currentJob.location || "",
                    country: currentJob.country || "",
                    no_of_staff: currentJob.no_of_staff || "",
                    role_title: currentJob.role_title || "",
                    job_level: jobLevelValue,
                    reports_to: currentJob.reports_to || "",
                    job_type: jobTypeValue,
                    industry: industryValue,
                    about_company: currentJob.about_company || "",
                    about_hiring_manager: currentJob.about_hiring_manager || "",
                    salary: currentJob.salary || "",
                    duration: durationValue,
                    salary_range: currentJob.salary_range || "",
                    currency:
                      currentJob.currency || currentJob.salary_currency || "0",
                    isCompanyRepresentative:
                      currentJob.isCompanyRepresentative || "",
                    canRecruiterRequest: currentJob.canRecruiterRequest || "",
                    job_tier: currentJob.job_tier || "",
                    estimated_views: currentJob.estimated_views || "",
                    worktype: currentJob.worktype || "",
                    applicant_benefit: currentJob.applicant_benefit || "",
                    company_id: currentJob.company_id || "",
                    skills_required: currentJob.skills_required || [],
                    is_draft: currentJob.is_draft || 0,
                  });
                  console.log(
                    "Currency processed:",
                    currentJob.currency || currentJob.salary_currency || "0",
                  );
                  setSelectedSkills(normalizeDuplicateSkills(currentJob));
                  setIsSuspended(currentJob.isSuspended === "1");
                  setIsDraft(
                    currentJob.is_draft === "1" || currentJob.is_draft === 1,
                  );
                  setConsentChecked(false);
                  setEditJobView(true);
                  setAnchorEl(null);
                  setTimeout(() => window.scrollTo(0, 0), 100);
                }}
              >
                Edit this job
              </MenuItem>

              <MenuItem
                className="px-4 py-2 medium-text"
                onClick={() => handleDuplicateJob(currentJob)}
              >
                Duplicate this job
              </MenuItem>
              <MenuItem
                className="px-4 py-2 medium-text"
                onClick={() => handleDelete(currentJob.id)}
              >
                Delete this job
              </MenuItem>
              <MenuItem
                className="py-2 medium-text rounded mr-3"
                style={{
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  marginLeft: "10px",
                  marginBottom: "10px",
                  paddingLeft: "0.7rem",
                  paddingRight: "0.7rem",
                  width: "fit-content",
                  minWidth: "auto",
                }}
                onClick={() => handleSuspend(jobIdValue)}
              >
                {currentJob?.isSuspended === "1" ? "Unhold" : "Hold"}
              </MenuItem>

              <MenuItem
                className="py-2 medium-text rounded mr-3"
                style={{
                  backgroundColor: "#28a745",
                  color: "#fff",
                  marginLeft: "10px",
                  marginBottom: "10px",
                  paddingLeft: "0.7rem",
                  paddingRight: "0.7rem",
                  width: "fit-content",
                  minWidth: "auto",
                }}
                onClick={() => handleCloseJob(jobIdValue)}
              >
                {currentJob?.isClosed === "1" ? "Reopen" : "Close"}
              </MenuItem>

              <Divider />
            </Menu>
            {filteredJobs.map((job) => {
              const postedAgo = getRelativePostedTime(job.date_created);
              const jobSummary = getJobExcerpt(job.about_company, 180);
              const jobReferralUrl =
                getShortInviteLink(job) || getJobDetailUrl(job);
              const shareTitle = getShareTitle(job);
              return (
                <div key={job.id} className="col-12 col-md-6 myjobs-card__col">
                  <Card additionalClass="mx-md-2 px-4 mb-4 myjobs-card">
                    <div className="d-flex mb-2 align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <img
                          width="30"
                          className="rounded-circle"
                          src={
                            job["created_by_profile"] &&
                            job.created_by_profile.image_url
                              ? job.created_by_profile.image_url
                              : ""
                          }
                          alt="avatar"
                        />
                        <span className="d-flex flex-column ml-3">
                          <h6 className="mb-0">
                            {job.created_by_profile &&
                              job.created_by_profile.first_name}{" "}
                            {job.created_by_profile &&
                              job.created_by_profile.last_name}
                          </h6>

                          <span className="co-gray">
                            @
                            {job.created_by_profile &&
                              job.created_by_profile.username}
                          </span>
                        </span>
                      </div>
                      <IconButton
                        onClick={(e) => {
                          handleClick(e);
                          setCurrentJob(job);
                          setJobIdValue(job.id);
                          setlocation(job.location);
                          setcountryvalue(job.country);
                          setno_of_staff(job.no_of_staff);
                          setrole_title(job.role_title);
                          setjob_level(job.job_level);
                          setjob_type(job.job_type);
                          setreports_to(job.reports_to);
                          setindustryvalue(job.industry);
                        }}
                      >
                        <svg width="20" height="15">
                          <use href={`${icons}#dots`}></use>
                        </svg>
                      </IconButton>
                    </div>
                    <div className="d-flex justify-content-start ml-4 my-3">
                      <span className="mr-2">
                        <svg width="17" height="16" className="mr-1">
                          <use href={`${icons}#briefcase`}></use>
                        </svg>
                        {currentJob?.job_level?.title}
                      </span>
                      <span className="mr-2">
                        <svg width="14" height="14" className="mr-1">
                          <use href={`${icons}#mappin`}></use>
                        </svg>
                        {job.location || "Location not specified"}
                      </span>
                      <span className="co-gray small-text">
                        Posted {postedAgo}
                      </span>
                    </div>

                    <div className="d-flex justify-content-start align-items-center my-1">
                      <span
                        className="px-2 py-1 small-text rounded mr-3"
                        style={{
                          backgroundColor: "#0d6efd",
                          color: "#fff",
                          fontSize: "0.75rem",
                          fontWeight: "bold",
                        }}
                      >
                        Tier {job.job_tier}
                      </span>
                      {job.job_tier == 2 && (
                        <span
                          className="px-2 py-1 small-text rounded mr-3"
                          style={{
                            backgroundColor: "#28a745",
                            color: "#fff",
                            fontSize: "0.75rem",
                            fontWeight: "bold",
                          }}
                        >
                          {job.views_left} views left
                        </span>
                      )}
                      {job.isSuspended === "1" && (
                        <span
                          className="px-2 py-1 small-text rounded"
                          style={{
                            backgroundColor: "#ffc107",
                            color: "#000",
                            fontSize: "0.75rem",
                            fontWeight: "bold",
                          }}
                        >
                          On Hold
                        </span>
                      )}
                      {job.is_draft === "1" && (
                        <span
                          className="px-2 py-1 small-text rounded"
                          style={{
                            backgroundColor: "#6c757d",
                            color: "#fff",
                            fontSize: "0.75rem",
                            fontWeight: "bold",
                          }}
                        >
                          Draft
                        </span>
                      )}
                      {job.isClosed === "1" && (
                        <span
                          className="px-2 py-1 small-text rounded"
                          style={{
                            backgroundColor: "#dc3545",
                            color: "#fff",
                            fontSize: "0.75rem",
                            fontWeight: "bold",
                          }}
                        >
                          Closed
                        </span>
                      )}
                    </div>

                    <Divider />

                    <div className="pb-3">
                      <b className="d-block my-3 co-primary">
                        {job.role_title}
                      </b>
                      <div>
                        <p className="mb-2 small-text" style={jobExcerptStyle}>
                          {jobSummary || "No additional details provided yet."}
                        </p>
                        <button
                          style={{ display: "inline" }}
                          type="button"
                          onClick={() => openDetails(job)}
                          className="co-primary bg-white borderless"
                        >
                          <b>See More</b>
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="small-text thin-text">
                        {job.total_likes} Likes
                      </span>
                    </div>

                    <Divider />

                    <div className="d-flex pt-2 align-items-center justify-content-end">
                      <LinkButton
                        label="Invite to Apply"
                        onClick={() => openInviteDetails(job)}
                      />
                    </div>
                  </Card>
                  {open && (
                    <Dialog
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="alert-dialog-slide-title"
                      aria-describedby="alert-dialog-slide-description"
                      maxWidth="md"
                      fullWidth
                      PaperProps={{
                        style: {
                          borderRadius: "1rem",
                          padding: "0",
                          maxHeight: "90vh",
                          margin: "16px",
                          width: "100%",
                          maxWidth: "900px",
                        },
                      }}
                    >
                      <>
                        <div
                          className="d-flex justify-content-between align-items-start"
                          style={{
                            padding: "16px 20px",
                            borderBottom: "1px solid #e0e0e0",
                            position: "sticky",
                            top: 0,
                            backgroundColor: "#fff",
                            zIndex: 1,
                          }}
                        >
                          <div
                            style={{
                              flex: 1,
                              paddingRight: "16px",
                              minWidth: 0,
                            }}
                          >
                            <h2
                              className="mb-1"
                              style={{
                                wordBreak: "break-word",
                                fontSize: "1.5rem",
                                fontWeight: "600",
                                lineHeight: "1.3",
                                margin: 0,
                              }}
                            >
                              {currentJob.role_title}
                            </h2>
                            <p
                              className="mb-0 co-darkgray"
                              style={{
                                wordBreak: "break-word",
                                fontSize: "0.95rem",
                                marginTop: "4px",
                              }}
                            >
                              {currentJob.campany_name}
                            </p>
                          </div>
                          <IconButton
                            onClick={handleClose}
                            style={{
                              padding: "8px",
                              flexShrink: 0,
                            }}
                          >
                            <svg width="24" height="24">
                              <use href={`${icons}#close`}></use>
                            </svg>
                          </IconButton>
                        </div>

                        <div
                          style={{
                            borderBottom: "1px solid #e0e0e0",
                            position: "sticky",
                            top: "77px",
                            backgroundColor: "#fff",
                            zIndex: 1,
                          }}
                        >
                          <div
                            className="d-flex px-3 py-2 flex-wrap"
                            style={{ gap: "8px" }}
                          >
                            <button
                              onClick={viewJobDetails}
                              className={`px-3 py-2 fw-bold border-0 rounded ${
                                subSection === "details"
                                  ? "co-white"
                                  : "co-primary"
                              }`}
                              style={{
                                backgroundColor:
                                  subSection === "details"
                                    ? "#0d6efd"
                                    : "transparent",
                                transition: "all 0.3s ease",
                                fontSize: "14px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Job
                            </button>
                            <button
                              onClick={viewDocument}
                              className={`px-3 py-2 fw-bold border-0 rounded ${
                                subSection === "documents"
                                  ? "co-white"
                                  : "co-primary"
                              }`}
                              style={{
                                backgroundColor:
                                  subSection === "documents"
                                    ? "#0d6efd"
                                    : "transparent",
                                transition: "all 0.3s ease",
                                fontSize: "14px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Additional Documents
                            </button>
                          </div>

                          <div
                            className="d-flex flex-wrap px-3 py-2"
                            style={{ gap: "12px", fontSize: "14px" }}
                          >
                            <span className="d-flex align-items-center">
                              <svg
                                width="16"
                                height="16"
                                className="mr-1"
                                style={{ flexShrink: 0 }}
                              >
                                <use href={`${icons}#briefcase`}></use>
                              </svg>
                              <span style={{ wordBreak: "break-word" }}>
                                {currentJob?.job_level?.title ||
                                  "Not specified"}
                              </span>
                            </span>
                            <span className="d-flex align-items-center">
                              <svg
                                width="14"
                                height="14"
                                className="mr-1"
                                style={{ flexShrink: 0 }}
                              >
                                <use href={`${icons}#mappin`}></use>
                              </svg>
                              <span style={{ wordBreak: "break-word" }}>
                                {currentJob.location || "Not specified"}
                              </span>
                            </span>
                            <span className="d-flex align-items-center">
                              <svg
                                width="20"
                                height="16"
                                className="mr-1"
                                style={{ flexShrink: 0 }}
                              >
                                <use href={`${icons}#persons`}></use>
                              </svg>
                              <span>
                                {currentJob.no_of_staff || "Not specified"}{" "}
                                workers
                              </span>
                            </span>
                          </div>
                        </div>

                        <DialogContent
                          style={{
                            padding: "20px",
                            overflowX: "hidden",
                            overflowY: "auto",
                            wordBreak: "break-word",
                            maxWidth: "100%",
                          }}
                        >
                          <style>
                            {`
            /* Ensure all content respects container width */
            .MuiDialogContent-root * {
              max-width: 100% !important;
              word-wrap: break-word !important;
              overflow-wrap: break-word !important;
              box-sizing: border-box !important;
            }

            .MuiDialogContent-root img {
              max-width: 100% !important;
              height: auto !important;
              display: block !important;
            }

            .MuiDialogContent-root pre,
            .MuiDialogContent-root code {
              white-space: pre-wrap !important;
              word-break: break-word !important;
              overflow-x: auto !important;
              max-width: 100% !important;
            }

            .MuiDialogContent-root table {
              display: block !important;
              overflow-x: auto !important;
              max-width: 100% !important;
            }

            .MuiDialogContent-root iframe,
            .MuiDialogContent-root video {
              max-width: 100% !important;
              height: auto !important;
            }

            /* Fix for long URLs */
            .MuiDialogContent-root a {
              word-break: break-all !important;
              overflow-wrap: break-word !important;
            }

            /* Mobile specific fixes */
            @media (max-width: 768px) {
              .MuiDialog-paper {
                margin: 8px !important;
                width: calc(100vw - 16px) !important;
                max-width: calc(100vw - 16px) !important;
              }

              .MuiDialogContent-root {
                padding: 16px !important;
              }

              .MuiDialogContent-root h1 {
                font-size: 1.5rem !important;
              }

              .MuiDialogContent-root h2 {
                font-size: 1.3rem !important;
              }

              .MuiDialogContent-root h3 {
                font-size: 1.1rem !important;
              }
            }

            @media (max-width: 480px) {
              .MuiDialog-paper {
                margin: 4px !important;
                width: calc(100vw - 8px) !important;
                max-width: calc(100vw - 8px) !important;
                border-radius: 0.5rem !important;
              }

              .MuiDialogContent-root {
                padding: 12px !important;
              }
            }
          `}
                          </style>
                          <div style={{ width: "100%", overflowX: "hidden" }}>
                            {section === "details" && (
                              <ViewDetails
                                job={currentJob}
                                section={subSection}
                              />
                            )}
                          </div>
                        </DialogContent>
                      </>
                    </Dialog>
                  )}
                  {openInvite && (
                    <Dialog
                      open={openInvite}
                      onClose={handleInviteClose}
                      aria-labelledby="alert-dialog-slide-title"
                      aria-describedby="alert-dialog-slide-description"
                    >
                      <DialogContent>
                        <div className="py-4 mt-4">
                          <h5 className="co-primary text-center">
                            Refer people using your unique link
                          </h5>
                          <p className="mx-auto w-75 my-5 w-100">
                            <textarea
                              ref={textAreaRef}
                              value={currentJobReferralLink}
                              className="borderless w-100 copy-link"
                              onChange={() => {}}
                            />
                          </p>
                          <div className="d-flex px-4 mt-3 justify-content-between">
                            <CustomButton
                              backgroundColor="#41B883"
                              color="#fff"
                              text="Copy Link"
                              handleClick={copyToClipboard}
                              additionalClass="mr-3 bg-primary"
                            />
                            <CustomButton
                              backgroundColor="#41B883"
                              color="#fff"
                              text="Share to Social"
                              handleClick={copyToClipboard}
                              additionalClass="bg-dargrey"
                            />
                          </div>
                          <div
                            className="mx-auto w-75 w-100 mt-4"
                            style={{ textAlign: "center" }}
                          >
                            <h6>Share to Social Network</h6>
                            <div>
                              <FacebookShareButton
                                url={jobReferralUrl || ""}
                                quote={shareTitle}
                                className="mr-2"
                                hashtag="#workbrook #job"
                              >
                                <FacebookIcon size={32} round />
                              </FacebookShareButton>

                              <TwitterShareButton
                                url={jobReferralUrl || ""}
                                title={shareTitle}
                                className="mr-2"
                                hashtags={hashtags}
                              >
                                <TwitterIcon size={32} round />
                              </TwitterShareButton>

                              <LinkedinShareButton
                                url={jobReferralUrl || ""}
                                className="mr-2"
                              >
                                <LinkedinIcon size={32} round />
                              </LinkedinShareButton>
                            </div>
                          </div>
                        </div>
                      </DialogContent>
                    </Dialog>
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={cancelDelete}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          style: {
            borderRadius: "1rem",
            padding: "1rem",
          },
        }}
      >
        <DialogTitle id="delete-dialog-title">Delete Job</DialogTitle>
        <DialogContent>
          <p>
            Are you sure you want to delete this job? This action cannot be
            undone.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            Cancel
          </Button>
          <Button
            onClick={confirmDelete}
            style={{ backgroundColor: "red", color: "white" }}
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Estimated Salary Modal for Tier 3 */}
      <Dialog
        open={showEstimatedSalaryModal}
        onClose={() => setShowEstimatedSalaryModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ backgroundColor: "#1ea7fd", color: "#fff" }}>
          Estimated Salary Confirmation
        </DialogTitle>
        <DialogContent style={{ padding: "24px" }}>
          {isEstimatingSalary ? (
            <div className="d-flex align-items-center justify-content-center py-4">
              <span className="ml-3">Calculating estimated salary...</span>
            </div>
          ) : estimatedSalaryData ? (
            <div>
              <div
                className="mb-4 p-3"
                style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}
              >
                <h5 className="mb-2">Estimated Market Salary</h5>
                <h3 style={{ color: "#1ea7fd", fontWeight: "bold" }}>
                  {estimatedSalaryData.currency}{" "}
                  {estimatedSalaryData.formatted_salary}
                </h3>
                <small className="text-muted">Per Annum</small>
              </div>

              <div className="mb-4">
                <h6 className="mb-2">
                  <strong>Important Information:</strong>
                </h6>
                <ul style={{ paddingLeft: "20px", marginBottom: "16px" }}>
                  <li className="mb-2">
                    This estimated salary is the{" "}
                    <strong>default market price</strong> for the role you are
                    posting, based on industry standards.
                  </li>
                  <li className="mb-2">
                    This is <strong>NOT</strong> the actual salary you will pay
                    the candidate. You can negotiate the final salary directly
                    with the hired candidate.
                  </li>
                  <li className="mb-2">
                    This estimated salary will be used to calculate your
                    platform posting fee.
                  </li>
                </ul>
              </div>

              <div
                className="p-3 mb-3"
                style={{
                  backgroundColor: "#fff3cd",
                  borderRadius: "8px",
                  border: "1px solid #ffc107",
                }}
              >
                <h6 className="mb-2">
                  <strong>Payment Breakdown:</strong>
                </h6>
                <p className="mb-1">
                  <strong>Total Fee:</strong> 10% of estimated salary ={" "}
                  {estimatedSalaryData.currency}{" "}
                  {(estimatedSalaryData.estimated_salary * 0.1).toLocaleString(
                    "en-US",
                  )}
                </p>
                <p className="mb-0">
                  <strong>Upfront Payment:</strong> 3% of estimated salary ={" "}
                  {estimatedSalaryData.currency}{" "}
                  {(estimatedSalaryData.estimated_salary * 0.03).toLocaleString(
                    "en-US",
                  )}
                </p>
              </div>

              <p className="text-muted" style={{ fontSize: "0.875rem" }}>
                By clicking "Accept & Continue", you acknowledge that you
                understand these terms and agree to proceed with the job update.
              </p>
            </div>
          ) : null}
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <CustomButton
            backgroundColor="#e0e0e0"
            color="#333"
            text="Cancel"
            handleClick={() => {
              setShowEstimatedSalaryModal(false);
              setEstimatedSalaryData(null);
            }}
            style={{ padding: "10px 24px", marginRight: "12px" }}
          />
          <CustomButton
            backgroundColor="#1ea7fd"
            color="#fff"
            text={isUpdating ? "Publishing..." : "Accept & Continue"}
            handleClick={submitJobWithEstimatedSalary}
            disabled={isUpdating || !estimatedSalaryData}
            style={{ padding: "10px 24px" }}
          />
        </DialogActions>
      </Dialog>
    </Layout>
  );
};

// const SalaryRow = ({ handleChange, duration }) => {
//   const numberWithCommas = (x) => {
//     return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//   };
//   const handleBlur = (e) => {
//     const text = e.target.value ? e.target.value : "";
//     document.querySelector("#report-salary").type = "text";
//     const stripped = text.replaceAll(",", "");
//     const formatted = numberWithCommas(stripped);
//     document.querySelector("#report-salary").value = formatted;
//     handleChange({
//       target: {
//         value: text,
//         name: "salary",
//       },
//     });
//   };
//   const handleFocus = async (e) => {
//     const text = e.target.value ? e.target.value : "";
//     document.querySelector("#report-salary").type = "number";
//     const stripped = text.replaceAll(",", "");
//     if (!isNaN(stripped))
//       document.querySelector("#report-salary").value = stripped;

//     handleChange({
//       target: {
//         value: stripped,
//         name: "salary",
//       },
//     });
//   };
//   return (
//     <div className="d-flex justify-content-between">
//       <div style={{ marginRight: "10px", flexGrow: 1 }}>
//         <CustomInput
//           type="number"
//           name="salary"
//           label="Salary (in USD)"
//           id="report-salary"
//           onBlur={handleBlur}
//           onFocus={handleFocus}
//         />
//       </div>
//       <div
//         style={{
//           display: "flex",
//           marginRight: "10px",
//           flexGrow: 1,
//           marginTop: "13px",
//         }}
//       >
//         <FormControl
//           variant="standard"
//           className="custom-input w-25 w-100 mt-4"
//         >
//           <Select
//             id={duration}
//             label="Duration"
//             name="duration"
//             onChange={handleChange}
//             value={duration}
//           >
//             <MenuItem key="5" value="Hourly">
//               Hourly
//             </MenuItem>
//             <MenuItem key="1" value="Daily">
//               Daily
//             </MenuItem>
//             <MenuItem key="2" value="Weekly">
//               Weekly
//             </MenuItem>
//             <MenuItem key="3" value="Monthly">
//               Monthly
//             </MenuItem>
//             <MenuItem key="4" value="Annually">
//               Annually
//             </MenuItem>
//           </Select>
//         </FormControl>
//       </div>
//     </div>
//   );
// };

// SalaryRow.propTypes = {
//   handleChange: func.isRequired,
//   duration: string,
// };

const SalaryRangeRow = ({ handleChange, salary_range, duration, currency }) => {
  const [displayValue, setDisplayValue] = useState(salary_range || "");

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleSalaryChange = (e) => {
    const value = e.target.value;
    setDisplayValue(value);
    handleChange({
      target: {
        name: "salary_range",
        value: value,
      },
    });
  };

  const handleBlur = (e) => {
    const text = e.target.value ? e.target.value : "";
    // Only format if it's a pure number, otherwise keep as is for ranges like "200 - 500"
    if (/^\d+$/.test(text.replace(/,/g, ""))) {
      const stripped = text.replaceAll(",", "");
      const formatted = numberWithCommas(stripped);
      setDisplayValue(formatted);
      handleChange({
        target: {
          value: formatted,
          name: "salary_range",
        },
      });
    }
  };

  const handleCurrencyChange = (e) => {
    handleChange({
      target: {
        value: e.target.value,
        name: "currency",
      },
    });
  };

  // Update displayValue when salary_range prop changes
  useEffect(() => {
    setDisplayValue(salary_range || "");
  }, [salary_range]);

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        flexDirection: "column",
        alignItems: "center",
        padding: "0px",
        justifyContent: "space-between",
      }}
    >
      <div
        className="d-flex justify-content-between w-100"
        style={{ gap: "5px" }}
      >
        <CustomSelect
          handleChange={handleCurrencyChange}
          options={{
            0: "Select Currency",
            ...CURRENCY_OPTIONS.reduce(
              (acc, option) => ({
                ...acc,
                [option.value]: option.label,
              }),
              {},
            ),
          }}
          id="currency"
          name="currency"
          label="Currency"
          currentValue={currency}
        />

        <CustomSelect
          handleChange={handleChange}
          options={{
            0: "Select Duration",
            1: "Hourly",
            2: "Daily",
            3: "Weekly",
            4: "Monthly",
            5: "Annually",
          }}
          id="duration"
          name="duration"
          label="Duration"
          currentValue={duration}
        />
      </div>

      <div className="d-flex justify-content-between w-100">
        <CustomInput
          type="text"
          name="salary_range"
          label="Salary Range"
          id="report-salary"
          value={displayValue}
          onChange={handleSalaryChange}
          onBlur={handleBlur}
          placeholder="e.g. 50000 or 40000 - 60000"
        />
      </div>
    </div>
  );
};

SalaryRangeRow.propTypes = {
  handleChange: PropTypes.func.isRequired,
  salary_range: PropTypes.string,
  duration: PropTypes.string,
  currency: PropTypes.string,
};

const EstimatedViewsCalculation = ({ views, selectedCountry }) => {
  const viewCount = parseInt(views) || 0;
  if (viewCount === 0) return null;

  const isNigeria = selectedCountry === "160";
  const ratePerView = isNigeria ? 189.98 : 0.12;
  const currency = isNigeria ? "NGN" : "USD";
  const currencySymbol = isNigeria ? "₦" : "$";
  const totalCost = viewCount * ratePerView;
  const formattedCost = totalCost.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className="mt-2 p-2 bg-light rounded">
      <small className="text-muted">
        <strong>Cost Calculation:</strong>
        <br />
        {viewCount.toLocaleString()} views × {currencySymbol}
        {ratePerView} per view = {currencySymbol}
        {formattedCost} {currency}
      </small>
    </div>
  );
};

export default MyJobs;
